import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import i18n from "@/plugins/vue-i18n";
import { VIconSvg, VInput } from "@/components";
import { required, minValue, maxLength } from "@vuelidate/validators";
import ValidationService from "@/services/validation.service";
import NotifyService from "@/services/notify.service";
import { ref, computed } from "vue";
import { useVuelidate } from "@vuelidate/core";

interface Props {
  currencyList?: Array<{
    text: string;
    value: string;
  }>;
  hiddenCurrency: boolean;
  paymentType: string;
  value: {
    currency: string;
    amount: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputMoney',
  props: {
    currencyList: { default: () => [
    {
      text: "USD",
      value: "USD",
    },
  ] },
    hiddenCurrency: { type: Boolean, default: false },
    paymentType: { default: "" },
    value: { default: () => ({
    currency: "USD",
    amount: "",
  }) }
  },
  emits: ["input"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { DEPOSIT_MIN_VALUE, DEPOSIT_MAX_LENGTH, DEPOSIT_MIN_VALUE_WIRE_TRANSFER } =
  ValidationService;

const emit = __emit;

const props = __props;

const error = ref(false);

const classes = ref({
  dropdown: "dropdown",
  option: "option",
  selectedOption: "selected-option",
  selectedHighlightedOption: "selected-highlighted-option",
  optionContent: "option-content",
});

const validations = computed(() => {
  let amountMinValue = DEPOSIT_MIN_VALUE;

  if (props.paymentType === "wireTransfer") {
    amountMinValue = DEPOSIT_MIN_VALUE_WIRE_TRANSFER;
  }

  return {
    amount: {
      required,
      minValue: minValue(amountMinValue),
      maxLength: maxLength(DEPOSIT_MAX_LENGTH),
    },
  };
});

const amount = computed({
  get() {
    return props.value.amount;
  },
  set(amount) {
    const value = { ...props.value, amount };

    emit("input", value);
  },
});

const $v = useVuelidate(validations, { amount });

const currency = computed({
  get() {
    return props.value.currency;
  },
  set(currency) {
    const value = { ...props.value, currency };

    emit("input", value);
  },
});

const wrapperClasses = computed(() => {
  return {
    "hidden-currency": props.hiddenCurrency,
    error: error.value,
  };
});

const showCurrencyMethod = computed(() => {
  return !props.hiddenCurrency;
});

const isValid = () => {
  if ($v.value.$invalid) {
    $v.value.$touch();
  }

  return !$v.value.$invalid;
};

const onInput = () => {
  error.value = false;
};

const inputMoneyError = () => {
  const isFilled = !$v.value.amount.required.$invalid;
  const isMinValue = !$v.value.amount.minValue.$invalid;
  const maxLength = !$v.value.amount.maxLength.$invalid;

  error.value = false;

  if (!isFilled) {
    NotifyService.error(i18n.t("invalidFormatPleaseFillInTheDepositField"));
    error.value = true;
  } else if (!isMinValue) {
    error.value = true;

    props.paymentType === "wireTransfer"
      ? NotifyService.error(i18n.t("lowAmount500"))
      : NotifyService.error(i18n.t("yourEnteredAmountIsBelowTheMinimumNeeded"));
  } else if (!maxLength) {
    error.value = true;

    NotifyService.error(i18n.t("invalidFormat"));
  }
};

__expose({
  inputMoneyError,
  isValid,
});

return (_ctx: any,_cache: any) => {
  const _component_t_rich_select = _resolveComponent("t-rich-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper-input-money", wrapperClasses.value])
  }, [
    (showCurrencyMethod.value)
      ? (_openBlock(), _createBlock(_component_t_rich_select, {
          key: 0,
          ref: "select",
          modelValue: currency.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currency).value = $event)),
          classes: classes.value,
          class: "select",
          options: _ctx.currencyList,
          wrapped: "",
          "hide-search-box": true
        }, {
          arrow: _withCtx(() => [
            _createVNode(_unref(VIconSvg), {
              name: "UnfoldMore",
              size: "xs",
              color: "fc-subduet",
              class: "arrow-icon"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "classes", "options"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VInput), {
      modelValue: amount.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((amount).value = $event)),
      "data-cy": "payments-amount-input",
      "validation-rule": "float",
      class: "input-money",
      onInput: onInput
    }, null, 8, ["modelValue"])
  ], 2))
}
}

})